import '@/App.css';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Toaster } from 'sonner';
import DevArea from './components/DevArea';
import StoreHome, { PublicGate } from './components/store/StoreHome';
import StorePlayer from './components/store/StorePlayer';
import Profile from './components/store/Profile';
import LegalPage from './components/LegalPage';
import CookieBanner from './components/CookieBanner';
import { PlayerProvider, AuthCallback } from './components/store/PlayerAuth';
import { AuthDialog } from './components/store/AuthDialog';
import { useEffect } from 'react';
import { loadRuntime } from './lib/runtime';
import { BrandProvider } from './components/BrandProvider';
import JobBadge from './components/JobBadge';
import { jobs } from './lib/jobs';

function AdminRoute() {
  sessionStorage.setItem('nexora.devview', 'admin');
  return <Navigate to="/dev" replace />;
}

function AppRouter() {
  const location = useLocation();
  if (/(session_id|apple_code|apple_error)=/.test(location.hash || '')) return <AuthCallback />;
  return (
    <>
    {location.pathname !== '/dev' && <JobBadge />}
    <Routes>
      <Route path="/" element={<StoreHome />} />
      <Route path="/gioco/:id" element={<PublicGate><StorePlayer /></PublicGate>} />
      <Route path="/profilo" element={<PublicGate><Profile /></PublicGate>} />
      <Route path="/legal" element={<LegalPage />} />
      <Route path="/legal/:tab" element={<LegalPage />} />
      <Route path="/privacy" element={<Navigate to="/legal/privacy" replace />} />
      <Route path="/termini" element={<Navigate to="/legal/termini" replace />} />
      <Route path="/dev" element={<DevArea />} />
      <Route path="/admin" element={<AdminRoute />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
    </>
  );
}

export default function App() {
  useEffect(() => { loadRuntime(); jobs.resume(); }, []);
  return (
    <BrowserRouter>
      <BrandProvider>
      <PlayerProvider>
        <AppRouter />
        <AuthDialog />
        <CookieBanner />
      </PlayerProvider>
      </BrandProvider>
      <Toaster theme="dark" position="bottom-center" toastOptions={{ style: { background: 'rgb(var(--t-surface-rgb))', border: '1px solid rgb(var(--violet-500)/.35)', color: '#e0e7ff', fontFamily: 'JetBrains Mono' } }} />
    </BrowserRouter>
  );
}
